module.exports = __webpack_public_path__ + "img/ftlogo.e408b02c.jpg";